export function ucFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatString(str, ...values) {
    let i = -1;
    return str.replace(/{\d+}/g, () => {
        i++;
        return values[i];
    });
}

export function splitByCapitalLetter(value, separator = '-') {
    const reg = /^[A-Z]?[^A-Z]*|[A-Z][^A-Z]*/g;

    return value.match(reg)?.join(separator).toLocaleLowerCase() || '';
}
